const getters = {
    complaints: (state) => state.complaints,
    complaintId: (state) => state.complaintId,
    newComplaint: (state) => state.newComplaint,
    feedback: (state) => state.feedback,
    loading: state => state.loading
};

export default getters;